export const TYPES = {
  ENERGY: 'ENERGY',
  LIVE: 'LIVE',
  REVIEW: 'REVIEW',
  CAMERA_TO_SCORE_GAME: 'CAMERA_TO_SCORE_GAME',
  DEFAULT: 'DEFAULT',
  NPC_GAME: 'NPC_GAME',
};

export default {TYPES};
